var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoyBeans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_558_57776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_11-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5574 3.74194C13.6124 3.37417 13.5733 3.01016 13.4495 2.67401C13.4966 2.91386 13.5029 3.16303 13.4654 3.41403C13.2953 4.46051 12.649 5.42814 11.6739 6.09632C9.83047 7.19077 7.52261 7.40518 5.58045 6.66238C4.85788 6.40097 4.35117 5.89124 4.12671 5.28677C4.27098 6.03151 4.82227 6.68261 5.67239 6.99029C7.61455 7.73309 9.92241 7.51869 11.7658 6.42423C12.741 5.75605 13.3871 4.78854 13.5573 3.74194H13.5574Z",
    fill: "#FFBB5E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_10-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4656 3.41412C13.5775 2.6649 13.2997 1.93179 12.7088 1.4166C12.0238 0.863012 10.9973 0.744421 10.1089 1.11643C9.7672 1.25731 9.43517 1.41708 9.11489 1.59467C8.49541 1.88733 7.81305 2.05001 7.12537 2.06915C5.94261 2.04868 4.81387 2.63473 4.23993 3.56723C3.62396 4.79602 4.21897 6.16982 5.58065 6.66259C7.52281 7.40539 9.83068 7.19098 11.6741 6.09653C12.6492 5.42835 13.2955 4.46084 13.4656 3.41424V3.41412Z",
    fill: "#FFD47F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_9-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.94 3.46825C13.0394 2.80225 12.7925 2.15042 12.2673 1.69253C11.6584 1.20036 10.7458 1.0951 9.95605 1.42567C9.65224 1.55093 9.35703 1.6929 9.07236 1.85074C8.52168 2.11081 7.91516 2.25557 7.30379 2.27253C6.25246 2.25436 5.24898 2.77536 4.73888 3.60417C4.19123 4.69656 4.72023 5.91772 5.93073 6.35575C7.65714 7.01605 9.70881 6.82551 11.3475 5.85255C12.2142 5.25851 12.7888 4.39845 12.94 3.46813V3.46825Z",
    fill: "#FFDC8D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_8-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62223 14.0705C8.89127 13.8138 9.08364 13.5024 9.19217 13.1609C9.0823 13.3792 8.9344 13.5799 8.75076 13.7552C7.9744 14.4773 6.8705 14.8451 5.69052 14.7746C3.56327 14.5081 1.60912 13.2616 0.531017 11.4836C0.120732 10.8338 0.0332728 10.1204 0.226847 9.50543C-0.116087 10.1822 -0.0801095 11.0345 0.402614 11.7989C1.48072 13.5769 3.43487 14.8234 5.56212 15.0899C6.74209 15.1603 7.846 14.7926 8.62235 14.0705H8.62223Z",
    fill: "#FFBB5E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_7-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75076 13.7551C9.29877 13.232 9.52917 12.4827 9.37848 11.7133C9.17715 10.8559 8.4392 10.1325 7.50936 9.88128C7.15311 9.78292 6.79285 9.70551 6.4309 9.64919C5.76223 9.50031 5.12349 9.21031 4.56869 8.80354C3.64722 8.06195 2.39625 7.83228 1.37097 8.21652C0.130666 8.80911 -0.242067 10.2591 0.531017 11.4835C1.60912 13.2616 3.56327 14.508 5.69052 14.7745C6.8705 14.8449 7.97428 14.4773 8.75076 13.7552V13.7551Z",
    fill: "#FFD47F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_6-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30244 13.4755C8.78952 13.0106 8.99436 12.3443 8.8605 11.6604C8.68147 10.8982 8.0254 10.2552 7.19889 10.0319C6.88213 9.94441 6.56197 9.87549 6.24023 9.82558C5.64582 9.69318 5.07794 9.43528 4.5848 9.07381C3.76557 8.41448 2.65367 8.21049 1.74225 8.55209C0.639676 9.0789 0.308372 10.3678 0.995571 11.4562C1.95399 13.0367 3.69107 14.1448 5.58211 14.3817C6.63101 14.4443 7.61221 14.1175 8.30244 13.4756V13.4755Z",
    fill: "#FFDC8D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_5-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5396 7.34208C12.2127 7.51954 11.9456 7.76981 11.7517 8.07107C11.9149 7.88913 12.11 7.73407 12.3332 7.61294C13.2713 7.11895 14.4329 7.05269 15.5534 7.42918C17.537 8.2426 19.0973 9.95654 19.673 11.9547C19.8991 12.6891 19.7971 13.4005 19.4495 13.9436C19.9574 13.3801 20.1455 12.5479 19.8795 11.6838C19.3036 9.6858 17.7434 7.97186 15.7598 7.15844C14.6393 6.78183 13.4778 6.84821 12.5396 7.3422V7.34208Z",
    fill: "#FFBB5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_4-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3332 7.61302C11.6676 7.97461 11.2493 8.6377 11.1936 9.41975C11.1638 10.2999 11.687 11.1911 12.5187 11.6766C12.8369 11.8647 13.1643 12.0337 13.4989 12.1826C14.1054 12.5012 14.6461 12.9482 15.0752 13.4858C15.7708 14.4425 16.9182 14.9912 18.0083 14.8884C19.3604 14.6407 20.0993 13.3386 19.6732 11.9546C19.0974 9.95662 17.5372 8.24256 15.5536 7.42914C14.4331 7.05265 13.2715 7.11891 12.3332 7.6129V7.61302Z",
    fill: "#FFD47F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6927 8.00006C12.101 8.32144 11.7291 8.91088 11.6795 9.60607C11.653 10.3885 12.1182 11.1806 12.8576 11.6123C13.1404 11.7795 13.4315 11.9298 13.729 12.0621C14.2682 12.3453 14.7487 12.7426 15.1303 13.2206C15.7486 14.0711 16.7685 14.5588 17.7376 14.4675C18.9395 14.2472 19.5963 13.0898 19.2177 11.8595C18.7059 10.0833 17.3189 8.55971 15.5555 7.83665C14.5594 7.50196 13.5269 7.56095 12.6928 8.00006H12.6927Z",
    fill: "#FFDC8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15026 2.59785C6.59304 2.7804 9.40022 2.57217 9.73068 1.98467C9.95647 1.58335 7.38296 2.52166 7.15026 2.59785ZM15.4827 13.1476C15.9638 13.4827 14.1079 11.3662 13.4398 11.456C12.9835 11.5173 15.2817 13.0075 15.4827 13.1476ZM4.2641 9.23617C3.71208 9.0386 6.05677 10.5962 6.6782 10.3349C7.10265 10.1564 4.49474 9.31891 4.2641 9.23617Z",
    fill: "#DD7D39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1-2",
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74657 10.5656C8.46708 11.021 8.79027 11.905 8.5331 12.7177C8.76386 12.3366 8.80905 11.8714 8.65617 11.4529C8.5033 11.0345 8.16861 10.708 7.74657 10.5655V10.5656ZM18.837 12.007C18.9932 12.845 18.5649 13.683 17.7942 14.0472C18.2306 13.9572 18.6023 13.674 18.8051 13.2773C19.0079 12.8806 19.0195 12.4134 18.837 12.007ZM12.4687 10.9542C11.8922 10.3262 11.8115 9.38851 12.2722 8.67127C11.9498 8.97883 11.7845 9.41588 11.8228 9.85984C11.8609 10.3037 12.0986 10.7062 12.4687 10.9542ZM10.7158 1.51134C11.5643 1.42897 12.3617 1.92889 12.6573 2.7285C12.6057 2.286 12.356 1.89086 11.9787 1.65416C11.6012 1.41746 11.1367 1.36501 10.716 1.51134H10.7158ZM6.04208 5.96317C5.27881 5.58354 4.86743 4.73704 5.04041 3.9023C4.84975 4.30496 4.85205 4.77242 5.04683 5.17301C5.24162 5.57372 5.60769 5.86433 6.04208 5.96305V5.96317ZM1.32448 11.2144C0.95453 10.4464 1.14883 9.52539 1.79751 8.97241C1.39994 9.17337 1.11503 9.54392 1.02309 9.97989C0.931151 10.4159 1.04199 10.8699 1.32448 11.2144Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_57776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14.1967,
    fill: "white",
    transform: "translate(0 0.901672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoyBeans);
export default __webpack_public_path__ + "static/media/soy-beans.d866e28f0d67d0ac8d0271808e38ac81.svg";
export { ForwardRef as ReactComponent };